import { scrollDownToElement, scrollToElement } from 'common/utils/scroll';

export default class ScrollToElement {
    element: HTMLElement;
    offsetTop: number;

    constructor(element: HTMLElement, offsetTop: number) {
        this.element = element;
        this.offsetTop = offsetTop || 0;
    }

    handleClick() {
        if (!this.element) return;

        this.element.addEventListener('click', e => {
            e.preventDefault();
            const toElement = this._getElementToScrollTo(<HTMLElement>e.currentTarget);

            if (toElement) {
                this._scrollToElement(toElement);
            }
        });
    }

    scroll() {
        const toElement = this._getElementToScrollTo(this.element);

        if (toElement) {
            this._scrollToElement(toElement);
        }
    }

    scrollDownToElement() {
        const toElement = this._getElementToScrollTo(this.element);

        if (toElement) {
            scrollDownToElement(toElement, this.offsetTop, 200);
        }
    }

    _getElementToScrollTo(element: HTMLElement) {
        let toElementId = element.getAttribute('data-scrollto');

        if (!toElementId) {
            return;
        }

        if (toElementId.indexOf('#') === 0) {
            toElementId = toElementId.split('#')[1];
        }

        return document.getElementById(toElementId);
    }

    _scrollToElement(toElement: HTMLElement) {
        if (toElement) {
            scrollToElement(toElement, this.offsetTop);
        }
    }
}
